import { useInteractiveCallback } from '@/hook/useInteractiveCallback';

import { useAppDispatch, useAppSelector } from '../store';

import {
    PENDING_TEMPLATES_REDUCER_NAME,
    setPendingTemplates,
} from './pendingTemplates.slice';

export function usePendingTemplates() {
    const pendingTemplates = useAppSelector(
        (state) => state[PENDING_TEMPLATES_REDUCER_NAME].pendingTemplates,
    );

    const dispatch = useAppDispatch();

    const onChangePendingTemplates = useInteractiveCallback(
        (pendingTemplates: string[]) => {
            dispatch(setPendingTemplates({ pendingTemplates }));
        },
    );

    return {
        pendingTemplates,
        onChangePendingTemplates,
    };
}
